var render, staticRenderFns
import script from "./detail copy.vue?vue&type=script&lang=js"
export * from "./detail copy.vue?vue&type=script&lang=js"
import style0 from "./detail copy.vue?vue&type=style&index=0&id=1821fa30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821fa30",
  null
  
)

export default component.exports